import React from 'react';
import PropTypes from 'prop-types';
import { Margin, SubHeading, Direction, Column } from '@scotia/canvas-react';
import { Alignment } from '../Alignment/Alignment';

export const TwoColumnCardLayout = props => {
  const children = props.children;
  return (
    <Direction>
      <Column md={12} xs={12}>
        <Alignment xs="left" md="left">
          <SubHeading>{props.title}</SubHeading>
        </Alignment>
      </Column>
      {React.Children.map(children, child => {
        return (
          <Column md={6} xs={6}>
            <Margin side="top" xs={12} md={12}>
              {child}
            </Margin>
          </Column>
        );
      })}
    </Direction>
  );
};

TwoColumnCardLayout.propTypes = {
  /** Title to be shown on the top */
  title: PropTypes.string.isRequired,
  /** DataPairs to use in the TwoColumnLayout  */
  children: PropTypes.node.isRequired
};
